import { render, staticRenderFns } from "./BigImageSlider.vue?vue&type=template&id=2891bd4b"
import script from "./BigImageSlider.vue?vue&type=script&lang=js"
export * from "./BigImageSlider.vue?vue&type=script&lang=js"
import style0 from "./BigImageSlider.vue?vue&type=style&index=0&id=2891bd4b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports